// extracted by mini-css-extract-plugin
export default {"profilesWrapper":"ProfilesWrapper_profilesWrapper__O0pxl"};